import PropTypes from 'prop-types';

import CommunityCurrentMessageContainer from './CommunityCurrentMessageContainer';

import ThreadTemplateComponent from '../../MessagesTemplate/ThreadTemplate/ThreadTemplateComponent';

import { CHARACTER_LIMIT } from './constants';

import { history } from '../../../store';

const CommunityMessagesWidgetComponent = ({
  currentChatId,
  handleNewUserMessage,
  widgetHeader,
  isInputDisabled,
  titleWithUrl,
  subtitleWithUrl,
  isMobileScreen,
  getChatById,
  setInputValue,
  inputValue,
  baseUrl,
  attachModalType,
  setAttachModalType,
  isAttachIconShown,
  setDocumentAsAttachment,
  checkNewAttachment,
  attachmentDocumentId,
  attachmentDocumentName,
}) => {
  const title = titleWithUrl ?? widgetHeader?.title;

  const showInput = !!(currentChatId && title);

  const isSendButtonDisabled = isInputDisabled || !inputValue;

  const hasSelectedThread = currentChatId > 0;

  const arrowBackOnclick = () => {
    history.push(baseUrl);
  };
  const isArrowBackActive = isMobileScreen;
  const isMessagesContainerActive = !hasSelectedThread;

  return (
    <ThreadTemplateComponent
      arrowBackOnclick={arrowBackOnclick}
      attachModalType={attachModalType}
      isMessagesContainerActive={isMessagesContainerActive}
      showInput={showInput}
      isArrowBackActive={isArrowBackActive}
      isInputDisabled={isInputDisabled}
      isSendButtonDisabled={isSendButtonDisabled}
      characterLimit={CHARACTER_LIMIT}
      inputValue={inputValue}
      titleWithUrl={titleWithUrl}
      subtitleWithUrl={subtitleWithUrl}
      widgetHeader={widgetHeader}
      setInputValue={setInputValue}
      title={title}
      isAttachIconShown={isAttachIconShown}
      setAttachModalType={setAttachModalType}
      handleNewUserMessage={handleNewUserMessage}
      setDocumentAsAttachment={setDocumentAsAttachment}
      checkNewAttachment={checkNewAttachment}
      widgetType="community"
      attachmentDocumentId={attachmentDocumentId}
      attachmentDocumentName={attachmentDocumentName}
    >
      <CommunityCurrentMessageContainer
        currentChatId={currentChatId}
        getChatById={getChatById}
      />
    </ThreadTemplateComponent>
  );
};

CommunityMessagesWidgetComponent.defaultProps = {
  attachmentDocumentName: null,
  attachmentDocumentId: null,
  attachModalType: null,
  currentChatId: null,
  widgetHeader: null,
  titleWithUrl: null,
  subtitleWithUrl: null,
  inputValue: null,
};

CommunityMessagesWidgetComponent.propTypes = {
  attachmentDocumentId: PropTypes.number,
  attachmentDocumentName: PropTypes.string,
  attachModalType: PropTypes.string,
  currentChatId: PropTypes.number,
  handleNewUserMessage: PropTypes.func.isRequired,
  widgetHeader: PropTypes.instanceOf(Object),
  isInputDisabled: PropTypes.bool.isRequired,
  titleWithUrl: PropTypes.node,
  subtitleWithUrl: PropTypes.node,
  isMobileScreen: PropTypes.bool.isRequired,
  getChatById: PropTypes.func.isRequired,
  setInputValue: PropTypes.func.isRequired,
  inputValue: PropTypes.string,
  baseUrl: PropTypes.string.isRequired,
  setAttachModalType: PropTypes.func.isRequired,
  isAttachIconShown: PropTypes.bool.isRequired,
  setDocumentAsAttachment: PropTypes.func.isRequired,
  checkNewAttachment: PropTypes.func.isRequired,
};

export default CommunityMessagesWidgetComponent;
